import { useEmbeddedAuth } from '@src/contexts/embedded-auth/useEmbeddedAuth';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface RequireAuthType {
  children: React.ReactNode;
}

const EXCLUSSION_ROUTES = [
  '/welcome',
  '/sign-in',
  '/callback',
  '/invitation/',
  '/review-invitation',
  '/faq',
];

function RequireAuth({ children }: RequireAuthType) {
  const { isAuthenticated } = useEmbeddedAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isExcluded = EXCLUSSION_ROUTES.some((exclussion) =>
    location.pathname.includes(exclussion)
  );
  const shouldRedirect = !isAuthenticated && !isExcluded;

  useEffect(() => {
    if (shouldRedirect) {
      navigate('/welcome', { state: { from: location } });
    }
  }, [shouldRedirect, navigate, location]);

  if (shouldRedirect) {
    return null;
  }

  return <React.Fragment>{children}</React.Fragment>;
}

export default RequireAuth;
